import {
    RULE_CATEGORY_PATCH_FAILURE,
    RULE_CATEGORY_PATCH_REQUEST,
    RULE_CATEGORY_PATCH_SUCCESS,
} from 'actions';

const initialState = {
    patching: false,
    hasErrors: false,
};

export const ruleCategoryPatchReducer = (state = initialState, action) => {
    const {type} = action;
    switch (type) {
        case RULE_CATEGORY_PATCH_SUCCESS: {return {
            ...state,
        }}

        case RULE_CATEGORY_PATCH_REQUEST: {return {
            ...state,
            patching: true,
        }}

        case RULE_CATEGORY_PATCH_FAILURE: {return {
            ...state,
            hasErrors: true,
        }}

        default: { return state }
    }
};
